import { SFHollywoodHills } from "./sf_hollywood_hills/SFHollywoodHills";

export function Fonts() {
  return (
    <>
      <SFHollywoodHills />
    </>
  );
}
